import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { connect } from "react-redux";
import GoogleMapReact from 'google-map-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {GoogleApiWrapper, Map, Marker, InfoWindow} from 'google-maps-react';

import { faMapMarkerAlt, faArrowLeft } from '@fortawesome/pro-solid-svg-icons'

import { mapColor } from "../../constants/colors";

import * as actions from '../../actions/ApiActions';

import Content from '../../components/Content/Content'
import Headline from "../../components/Headline/Headline";
import BookingWidget from "../../components/BookingWidget/BookingWidget";
import Section from "../../components/Section/Section";
import PhotoSlider from "../../components/PhotoSlider/PhotoSlider";
import InfoBox from "../../components/InfoBox/InfoBox";
import Modal from "../../components/Modal/Modal";
import PublicHeader from '../../components/PublicHeader/PublicHeader';
import ModalOverlay from "../../components/ModalOverlay/ModalOverlay";
import BookingModal from "../../components/BookingModal/BookingModal";

class MapContainer extends React.Component {
  render() {
    const { lat, lng } = this.props;
    return (
      <Map styles={mapColor} google={this.props.google} initialCenter={{
        lat: lat,
        lng: lng
      }} zoom={17}>

        <Marker
          name={'Current location'}
          icon={{
            url: "/marker.png",
          }}
        />

        <InfoWindow>
          <div>
            <h1>Test</h1>
          </div>
        </InfoWindow>
      </Map>
    );
  }
};

const MyMap = GoogleApiWrapper({
  apiKey: ('AIzaSyArk4neDB2zf0vS388DETeNVsYA1W7OZD0')
})(MapContainer);

class DetailContainer extends Component {
  static defaultProps = {
    center: {
      lat: 52.013450,
      lng: 8.531760
    },
    zoom: 17,
  };

  constructor(props) {
    super(props);

    const { currentResult, loadDoctorDetails, loadAppointmentDetails, loadUserData } = this.props;

    this.state = {
      openModal: null,
      profile: props.match.path === "/dashboard/profile"
    };

    // check if currentResult is set
    if (currentResult.doctors_id) {
      // load detail data
      loadDoctorDetails(currentResult.doctors_id);
    } else {
      loadAppointmentDetails(this.props.match.params.id);
    }

    if (this.state.profile) {
      loadDoctorDetails(localStorage.getItem('docID'));
    }

    this.toggleModal = this.toggleModal.bind(this);
    this.reservationAction = this.reservationAction.bind(this);
  }

  toggleModal(modal) {
    this.setState({
      openModal: modal
    });
  }

  reservationAction(data) {
    const { currentResult, makeReservation } = this.props;

    if (!data.firstname || !data.lastname || !data.email) {
      return;
    }

    makeReservation({
      appointmentID: currentResult.appointments_id,
      firstname: data.firstname,
      lastname: data.lastname,
      email: data.email,
      phone: data.phone
    });

    this.toggleModal(null)
  }

  render() {
    const { searchQuery, currentResult, apiResponse, history, match } = this.props;
    const { openModal, profile } = this.state;

    let showSearch = false;
    if (searchQuery.what !== "") {
      showSearch = true;
    }

    


    return (
      <div>
        {match.url.indexOf('iframe') >= 0 && (
          <PublicHeader history={history} match={match} iframe scrolled={this.state.scrolledDown} />
        )}
        <Content padding>
          <div>
            <div className={'map-wrapper'} style={{ height: '400px', width: '100%', position: 'relative' }}>
              <MyMap lat={currentResult.lat} lng={currentResult.lng} />
            </div>

            <Section>
              {
                !profile &&
                <BookingWidget appointment={currentResult}
                               bookingAction={() => this.toggleModal("BookingModal")} />
              }
              <Row>
                <Col lg={9}>
                {match.url.indexOf('iframe') >= 0 && (
                  <a style={{color: 'grey', marginTop: '-20px', marginBottom: '20px', display: 'inline-block'}} href="#" onClick={(e) => {
                    e.preventDefault();
                    history.goBack();
                  }}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    <span style={{marginLeft: '10px'}}>Zurück zur Übersicht</span></a>
                )}
                  <Headline large>{currentResult.name}</Headline>
                  <Headline small grey subtitle>{currentResult.subtitle}</Headline>

                  <Row>
                    <Col>
                      <InfoBox label="Homepage">
                        <a href={currentResult.homepage} target="_blank">
                          {currentResult.homepage}
                        </a>
                      </InfoBox>
                      <Row>
                        <Col>
                          <InfoBox label="Telefon">
                            {currentResult.phone}
                          </InfoBox>
                        </Col>
                        <Col>
                          <InfoBox label="E-Mail">
                            <a
                              href={'mailto:' + (currentResult.contactemail ? currentResult.contactemail : currentResult.email)}
                            >
                              {currentResult.contactemail ? currentResult.contactemail : currentResult.email}
                            </a>
                          </InfoBox>
                        </Col>
                      </Row>
                      {
                        currentResult.fax &&
                        <InfoBox label="Fax">
                          {currentResult.fax}
                        </InfoBox>
                      }

                    </Col>
                    <Col><InfoBox label="Öffnungszeiten">
                      <div dangerouslySetInnerHTML={{__html: currentResult.openinghours}} />
                    </InfoBox></Col>
                  </Row>

                </Col>
                <Col lg={3}>
                  <img src={currentResult.logo ? currentResult.logo : currentResult.profilepic} />
                </Col>
              </Row>
            </Section>

            <Section grey>

              <Headline>{currentResult.desheadline ? currentResult.desheadline : 'Unsere Praxis'}</Headline>

              <Row>
                <Col lg={6}>
                  <p>
                    <div dangerouslySetInnerHTML={{__html: currentResult.longdes}} />
                  </p>
                </Col>
                <Col lg={6}>
                  <PhotoSlider>
                    {
                      currentResult.images && currentResult.images.map((item) => {
                        return <img src={item} />;
                      })
                    }
                  </PhotoSlider>
                </Col>
              </Row>

            </Section>
          </div>
        </Content>

        <ModalOverlay visible={(openModal != null)} />

        <Modal
          visible={(openModal === "BookingModal")}
          closeAction={() => this.toggleModal(null)}
        >

          <BookingModal appointment={currentResult} submitAction={this.reservationAction} />

        </Modal>

      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    fachgruppen: state.fachgruppen,
    searchQuery: state.searchQuery,
    currentResult: state.currentResult,
  };
}

export default connect(mapStateToProps, actions)(DetailContainer);



// WEBPACK FOOTER //
// ./src/container/public/DetailContainer.js